/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureHub interface.
 */
export function instanceOfFxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureHub(value) {
    if (!('HubUrl' in value) || value['HubUrl'] === undefined)
        return false;
    return true;
}
export function FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureHubFromJSON(json) {
    return FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureHubFromJSONTyped(json, false);
}
export function FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureHubFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'HubUrl': json['hub_url'],
    };
}
export function FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureHubToJSON(json) {
    return FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureHubToJSONTyped(json, false);
}
export function FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureHubToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'hub_url': value['HubUrl'],
    };
}
//# sourceMappingURL=FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureHub.js.map